<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Rose Riot</h1>
<p class="BOD2">A simple crocheted rose motif can be used to create a stunning ring or earrings, or group them together to make a bouquet for a brooch or hairclip.</p>
<p class="IMAGE"><img alt="" src="images/C1-3.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-4.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-2.vue?356a8019